import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "untrusted",
  "use": "untrusted-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"untrusted\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.206 1.04A4.921 4.921 0 0111.748 0H3.255C2.948.993 2.14 2.486 0 3.329c.107 1.517.514 5.44 1.91 7.804l.014.024L12.206 1.04zM3.232 12.887c1.56 1.678 3.435 2.705 4.27 3.113 1.09-.532 3.967-2.123 5.59-4.867 1.393-2.36 1.8-6.287 1.908-7.804a6.3 6.3 0 01-1.32-.703L3.232 12.886z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol